"use strict";
var LOAD = 'load';
var READ_ONLY = 'readOnly';
module.exports = {
    LOAD: LOAD,
    READ_ONLY: READ_ONLY
};
